import Component from 'navigation/component/Component';
import resize from 'helpers/resize';
class HomeMedia extends Component {
    resize() {
        super.resize();
        const portrait = resize.ratio() < 1;
        const media = this.refs.homeMedia[0];
        if (!media)
            return;
        const srcLandscape = media.getAttribute('data-landscape');
        const srcsetLandscape = media.getAttribute('data-landscape-srcset');
        if (!srcLandscape)
            return;
        const video = media.tagName === 'VIDEO';
        if (!video)
            return;
        let srcPortrait = media.getAttribute('data-portrait');
        let srcsetPortrait = media.getAttribute('data-portrait-srcset');
        if (!srcPortrait) {
            srcPortrait = media.src;
            media.setAttribute('data-portrait', srcPortrait);
        }
        if (!video && !srcsetPortrait) {
            srcsetPortrait = media.srcset;
            media.setAttribute('data-portrait-srcset', srcsetPortrait);
        }
        const src = portrait && srcPortrait ? srcPortrait : srcLandscape;
        const srcset = portrait && srcsetPortrait ? srcsetPortrait : srcsetLandscape;
        if (media.src !== src) {
            media.src = src;
            if (!video)
                media.srcset = srcset;
            media?.play?.()?.catch?.(() => { });
        }
    }
}
export default HomeMedia;
